import React from 'react';
import { formatDate, getTrimmedName } from '~/util';

interface AnswerType {
    date: null | string;
    value: string | number;
}

export interface FocSubmitRowProps {
    gap: GapType;
    gapAction: FocActionType;
}

export function FocSubmitRow({ gap, gapAction }: FocSubmitRowProps) {
    let checked = false;
    const answers: Record<number, AnswerType> = {};
    gapAction.foc_action_details.forEach((detail) => {
        const answer = gap.submission_answer?.metadata?.responses.find(
            (x) => detail.id === parseInt(String(x.foc_action_detail?.id))
        );
        if (answer) {
            checked = true;
            answers[detail.id] = { value: answer.value, date: null };
            try {
                answers[detail.id].date = formatDate(answer.date);
            } catch (e) {
                answers[detail.id].date = null;
            }
        } else {
            answers[detail.id] = { date: null, value: '' };
        }
    });

    if (!checked) return null;

    return (
        <>
            {gapAction.foc_action_details.map((detail) => (
                <tr key={detail.id}>
                    <td className="col-gap-action-name" colSpan={2} rowSpan={1}>
                        <label className="form-label ms-4">{getTrimmedName(detail.name)}</label>
                    </td>
                    <td className="w-20 text-center">
                        <span>{answers[detail.id]?.date && answers[detail.id].date}</span>
                    </td>
                    <td className="w-35 text-center">
                        {detail.lookup_metadata?.length ? (
                            detail.lookup_metadata.map(
                                (lookup) =>
                                    answers[detail.id]?.value === lookup.SupplementalDataValue && (
                                        <label
                                            className="form-label me-3"
                                            key={lookup.SupplementalDataValue}
                                        >
                                            {lookup.SupplementalDataValueDescription}
                                        </label>
                                    )
                            )
                        ) : (
                            <span>
                                {answers[detail.id]?.value}
                                &nbsp;
                                {detail.units}
                            </span>
                        )}
                    </td>
                </tr>
            ))}
        </>
    );
}
